module.exports = __webpack_public_path__ + "media/stylesheets/images/userway_logo_images/autism-speaks-5cb86f698f05bb53f1bef4d8114fb40d.png";